module.exports = __webpack_public_path__ + "img/chips20000.3142c173.webp";